/**
 *
 * This is a type guard util to check if a value is a valid key of a specific object
 * @param value The value to check
 * @param targetObject The object to check against
 */
export function isKeyOfObject<ObjectType extends Record<PropertyKey, unknown>>(
    value: PropertyKey,
    targetObject: ObjectType,
): value is keyof ObjectType {
    return value in targetObject;
}
